<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">機構方案</h1>
                        <h2>大學專屬 AI 寫作輔助全套服務</h2>
                        <p>採用用量計費模式，讓全校師生都能輕鬆使用 Trinka 的 AI 寫作輔助，免去繁瑣的授權管理與資源浪費。</p>
                        <div class="btn-group">
                            <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button">免費試用申請</button>
                            <a href="https://calendly.com/trinkaai/meet" target="_blank"  id="autoEditGetStart" class="outline-btn">預約產品演示</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/enterprise/academic.webp" width="500" height="466" alt="Trinka enterprise" class="img-fluid md50" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd bg-light-purple">
    <div class="trinka_container container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="trinka-title mb-0">
                    <h2>全球頂尖大學的共同選擇</h2>
                    <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    <p>Trinka 機構方案採用按實際使用計費模式，免除未使用授權的浪費，並支援彈性續約，讓資源配置更有效率。</p>
                    <p>凡持有學校信箱的校內成員皆可使用，同時支援白名單與黑名單控管，讓使用權限管理更加彈性、安全。</p>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="text-center">
                    <img src="/assets/images/enterprise/Institution-Plan-world-map.webp" width="800" height="345" class="img-fluid" alt="Institution-Plan-world-map" />
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-10">
                <div class="trinka-title mb-0 text-center">
                    <h2>機構方案特色</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-none">
                    <div class="features_cards_icon">
                        <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M9.5 13.75C9.5 14.72 10.25 15.5 11.17 15.5H13.05C13.85 15.5 14.5 14.82 14.5 13.97C14.5 13.06 14.1 12.73 13.51 12.52L10.5 11.47C9.91 11.26 9.51001 10.94 9.51001 10.02C9.51001 9.17999 10.16 8.48999 10.96 8.48999H12.84C13.76 8.48999 14.51 9.26999 14.51 10.24" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 7.5V16.5" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17 3V7H21" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M22 2L17 7" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </div>
                    <div class="features_cards_desc">
                        <h3>使用量計費</h3>
                        <p>依實際使用量計費，免除未用授權浪費。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title">
                    <div class="features_cards_icon">
                        <svg width="40px" height="40px" viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 22.3201C17.5228 22.3201 22 17.8429 22 12.3201C22 6.79722 17.5228 2.32007 12 2.32007C6.47715 2.32007 2 6.79722 2 12.3201C2 17.8429 6.47715 22.3201 12 22.3201Z" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M2 12.3201H22" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 22.3201C13.933 22.3201 15.5 17.8429 15.5 12.3201C15.5 6.79722 13.933 2.32007 12 2.32007C10.067 2.32007 8.5 6.79722 8.5 12.3201C8.5 17.8429 10.067 22.3201 12 22.3201Z" stroke="#763393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </div>
                    <div class="features_cards_desc">
                        <h3>全校通用</h3>
                        <p>凡持有學校信箱的成員皆可使用，無需個別授權設定。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <svg fill="#763393" width="40px" height="40px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M960 95.888l-256.224.001V32.113c0-17.68-14.32-32-32-32s-32 14.32-32 32v63.76h-256v-63.76c0-17.68-14.32-32-32-32s-32 14.32-32 32v63.76H64c-35.344 0-64 28.656-64 64v800c0 35.343 28.656 64 64 64h896c35.344 0 64-28.657 64-64v-800c0-35.329-28.656-63.985-64-63.985zm0 863.985H64v-800h255.776v32.24c0 17.679 14.32 32 32 32s32-14.321 32-32v-32.224h256v32.24c0 17.68 14.32 32 32 32s32-14.32 32-32v-32.24H960v799.984zM736 511.888h64c17.664 0 32-14.336 32-32v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32zm0 255.984h64c17.664 0 32-14.32 32-32v-64c0-17.664-14.336-32-32-32h-64c-17.664 0-32 14.336-32 32v64c0 17.696 14.336 32 32 32zm-192-128h-64c-17.664 0-32 14.336-32 32v64c0 17.68 14.336 32 32 32h64c17.664 0 32-14.32 32-32v-64c0-17.648-14.336-32-32-32zm0-255.984h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.68-14.336-32-32-32zm-256 0h-64c-17.664 0-32 14.336-32 32v64c0 17.664 14.336 32 32 32h64c17.664 0 32-14.336 32-32v-64c0-17.68-14.336-32-32-32zm0 255.984h-64c-17.664 0-32 14.336-32 32v64c0 17.68 14.336 32 32 32h64c17.664 0 32-14.32 32-32v-64c0-17.648-14.336-32-32-32z"></path></g></svg>
                    </div>
                    <div class="features_cards_desc">
                        <h3>靈活有效期限</h3>
                        <p>訂閱期間可延展，並支援餘額累積，彈性高、運用更自由。</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards flex-title bt-1">
                    <div class="features_cards_icon">
                        <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle cx="12" cy="9" r="2" stroke="#763393" stroke-width="1.5"></circle> <path d="M16 15C16 16.1046 16 17 12 17C8 17 8 16.1046 8 15C8 13.8954 9.79086 13 12 13C14.2091 13 16 13.8954 16 15Z" stroke="#763393" stroke-width="1.5"></path> <path d="M3 10.4167C3 7.21907 3 5.62028 3.37752 5.08241C3.75503 4.54454 5.25832 4.02996 8.26491 3.00079L8.83772 2.80472C10.405 2.26824 11.1886 2 12 2C12.8114 2 13.595 2.26824 15.1623 2.80472L15.7351 3.00079C18.7417 4.02996 20.245 4.54454 20.6225 5.08241C21 5.62028 21 7.21907 21 10.4167C21 10.8996 21 11.4234 21 11.9914C21 14.4963 20.1632 16.4284 19 17.9041M3.19284 14C4.05026 18.2984 7.57641 20.5129 9.89856 21.5273C10.62 21.8424 10.9807 22 12 22C13.0193 22 13.38 21.8424 14.1014 21.5273C14.6796 21.2747 15.3324 20.9478 16 20.5328" stroke="#763393" stroke-width="1.5" stroke-linecap="round"></path> </g></svg>
                    </div>
                    <div class="features_cards_desc">
                        <h3>完整使用控管</h3>
                        <p>管理員可設定帳號白名單與黑名單，靈活控管使用權限。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="bg-light section-pd">
    <app-documark-for-universities></app-documark-for-universities>
</section>

<section class="list-wrapper-style-2 section-pd">
    <div class="trinka_container container">
        <div class="row">
            <div class="col-12">
                <div class="section-usecases rounded-sm">
                    <div class="row justify-content-center">
                        <div class="col-md-12 col-lg-12">
                            <div class="trinka-title mb-0 text-center">
                                <h2>全方位 AI 寫作工具</h2>
                                <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards  bt-none">
                                <h3 class="mb-2">寫作助理</h3>
                                <p class="mb-3">專為學術用途設計，有效提升語言品質。</p>
                                <ul>
                                    <li><a [routerLink]="['/features/grammar-checker']">文法檢查</a> <small class="d-block">(Cloud, MS Word and LaTeX)</small></li>
                                    <li><a [routerLink]="['/features/paraphraser']">文章改寫</a></li>
                                    <li><a [routerLink]="['/features/consistency-check']">一致性檢查</a></li>
                                    <li><a [routerLink]="['/features/inclusive-language-check']">中性語言檢查</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards">
                                <h3 class="mb-2">閱讀助理</h3>
                                <p class="mb-3">提升文獻理解效率，快速掌握重點。</p>
                                <ul>
                                    <li><a href="https://www.read.enago.com/copilot/" target="_blank">文獻審閱輔助</a></li>
                                    <li><a href="https://www.read.enago.com/summarizer/" target="_blank">摘要生成</a></li>
                                    <li><a href="https://www.read.enago.com/key-insights/" target="_blank">關鍵見解提取</a></li>
                                    <li><a href="https://www.read.enago.com/related-papers/" target="_blank">論文發現工具</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3 class="mb-2">誠信報告</h3>
                                <p class="mb-3">提供多元報告工具，協助全面檢視文件的誠信與原創性。</p>
                                <ul>
                                    <li><a [routerLink]="['/ai-content-detector']">AI 內容檢測工具</a></li>
                                    <li><a [routerLink]="['/features/plagiarism-check']">抄襲檢查</a></li>
                                    <li>寫作歷程追蹤 <span class="beta-badge postion-relative w-auto" style="margin-left:8px; top:inherit;right: inherit;">Coming Soon</span></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3 class="mb-2">引文協助工具</h3>
                                <p class="mb-3">檢查並提升引文品質，驗證、格式化及標準化各種主流引用格式。</p>
                                <ul>
                                    <li><a [routerLink]="['/features/citation-checker']">引文檢查器</a></li>
                                    <li><a [routerLink]="['/features/citation-formatter']">引文格式整理器</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3 class="mb-2">發表支援工具</h3>
                                <p class="mb-3">透過超過 25 項標準檢查，全面評估文件內容，有效提升論文發表成功率。</p>
                                <ul>
                                    <li><a [routerLink]="['/features/journal-finder']">期刊查找</a></li>
                                    <li><a [routerLink]="['/features/technical-checks']">技術合規檢查報告</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="list-wrapper-content-2 list-style-cards bt-1">
                                <h3 class="mb-2">生成式 AI 工具</h3>
                                <p class="mb-3">協助師生在安全控管下，放心地使用生成式 AI 工具。</p>
                                <ul>
                                    <li>/Ask</li>
                                    <li>AI Studio</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-10">
                <div class="trinka-title text-center">
                    <h3 class="text-white mb-4">無縫銜接您的學術寫作</h3>
                    <p class="text-white w-100">想知道我們的機構方案如何提升貴校的寫作能力嗎？立即申請免費試用，讓 Trinka 助您的大學領先一步。</p>
                </div>
                <div class="btn-group justify-content-center">
                    <button (click)="navigationService.goToEnterpriseForm()" class="white-btn nowrap" type="button">免費試用申請</button>
                </div>
            </div>
        </div>  
    </div>
</section>

<app-grammar-without-internet [windowsButton]="false"></app-grammar-without-internet>

<section class="bg-light">
    <app-security-section></app-security-section>
</section>

<section class="section-pd list-wrapper-style-2 tailoredSolutions">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>您的學術寫作助理，隨時隨地陪伴</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>為您的學生、教職員與研究人員提供便捷的寫作輔助工具，輕鬆整合於日常工作平台，提升效率與生產力。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>
                        雲端編輯器
                    </h3>
                    <p>
                        隨時隨地使用 Trinka 的完整功能，安全的網頁應用助您輕鬆寫作。
                    </p>
                    <a [routerLink]="['/trinkacloud']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>
                        MS Word 外掛程式
                    </h3>
                    <p>
                        在 Microsoft Word 內直接獲得 AI 智慧建議，提升課業、研究論文等學術寫作品質。
                    </p>
                    <a [routerLink]="['/wordplugin']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>
                        桌面應用程式
                    </h3>
                    <p>
                        在 Windows 各種應用程式中提供專業的文法修正，讓您寫作無憂。
                    </p>
                    <a [routerLink]="['/windows-desktop-app']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1 mh-xl">
                    <h3>
                        瀏覽器擴充功能
                    </h3>
                    <p>
                        支援您常用瀏覽器的即時寫作協助，隨時隨地提升文字品質。
                    </p>
                    <a [routerLink]="['/browser-plugin']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1 mh-xl">
                    <h3>API/JavaScript 整合</h3>
                    <p>
                        輕鬆將 Trinka 嵌入校園學習管理系統（LMS）或其他平台，打造專屬寫作支援方案。
                    </p>
                    <a [routerLink]="['/enterprise/grammar-checker-api']" class="text-link d-flex align-items-center mb-0">
                        了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier"><path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g>
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd bg-light-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>彈性訂價，量身打造</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>
                        Trinka 提供依用戶數或使用量計費的彈性方案，隨時調整用戶及使用限制，無額外費用。我們協助您制定簡便合約與單一付款方案（含採購訂單/發票）。
                    </p>
                    <div class="btn-group justify-content-center mt-4">
                        <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button">索取報價 </button>
                        <a href="https://calendly.com/trinkaai/meet" target="_blank" id="autoEditGetStart" class="outline-btn">預約產品演示</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-local-invoice></app-local-invoice>